// extracted by mini-css-extract-plugin
export var buttons = "styles-module--buttons--xmPlB";
export var schemaLabel = "styles-module--schemaLabel--0Vz9q";